export default __webpack_public_path__ + "static/media/inductionimage2.fa7458c8.png";